import s from './container1.module.scss'
import Man from '../../public/Me.png'

export function Presentation() {
  return (
    <div id="home" className={s.container}>
      <div className={s.image}>
        <img src={Man} alt="Man illustation with an Macbook in his front" />
      </div>
      <div className={s.text}>
        <h4 className={s.text1}>
          <svg
            width="4.938rem"
            height="3rem"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.409811 47.3962C0.409811 47.3962 0.409727 47.3963 0.540564 47.4697C0.611952 47.6016 0.612045 47.6016 0.612045 47.6016L0.61939 47.5976L0.641876 47.5855L0.730429 47.5382C0.808316 47.4967 0.923207 47.436 1.07095 47.3588C1.36645 47.2044 1.79333 46.9845 2.31837 46.7225C3.36861 46.1985 4.8109 45.5067 6.37975 44.8349C7.94916 44.1628 9.64228 43.5121 11.1948 43.0693C12.753 42.6248 14.1485 42.3961 15.1322 42.5499L15.1785 42.2535C14.1259 42.089 12.6764 42.3347 11.1125 42.7808C9.54291 43.2285 7.83687 43.8846 6.26166 44.5591C4.6859 45.2339 3.23811 45.9284 2.18444 46.4541C1.65752 46.717 1.22898 46.9378 0.932048 47.0929C0.925245 47.0964 0.918512 47.0999 0.911849 47.1034C0.956917 47.0199 1.00764 46.9253 1.06341 46.8204C1.30766 46.3614 1.64894 45.7059 2.03734 44.9196C2.81384 43.3475 3.78001 41.2499 4.53554 39.1525C5.28922 37.0603 5.84074 34.9487 5.77222 33.356C5.73791 32.5586 5.54747 31.871 5.12845 31.3832C4.70476 30.8901 4.06748 30.6243 3.19228 30.6328L3.19519 30.9328C4.00484 30.9249 4.54829 31.1683 4.9009 31.5787C5.25818 31.9946 5.43963 32.6049 5.4725 33.3689C5.53832 34.8989 5.00534 36.9631 4.2533 39.0508C3.50312 41.1333 2.54236 43.2197 1.76836 44.7867C1.38151 45.5699 1.04165 46.2227 0.798567 46.6795C0.677032 46.9079 0.579708 47.0873 0.512822 47.2096C0.479379 47.2707 0.453548 47.3175 0.436106 47.3489L0.416331 47.3845L0.409811 47.3962ZM0.540564 47.4697L0.612045 47.6016L0.156433 47.8481L0.409811 47.3962L0.540564 47.4697Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M38.8032 11.1122C25.9197 18.0561 14.4217 27.8131 7.47084 39.0643L7.72607 39.2219C14.6424 28.0267 26.0951 18.3023 38.9455 11.3763C51.7959 4.45035 66.03 0.330274 78.4998 0.330273V0.0302734C65.9696 0.0302729 51.6867 4.16841 38.8032 11.1122Z"
              fill="white"
            />
          </svg>
          Hello! I Am <strong>Ibrahim Memon</strong>
        </h4>
        <h4 className={s.text2}>A Designer who</h4>
        <h2 className={s.text3}>
          Judges a book <br />
          by its{' '}
          <strong>
            <svg
              width="11.813rem"
              height="3.813rem"
              viewBox="0 0 189 61"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M187.834 22.8917C188.145 26.6387 185.974 30.5091 181.553 34.3141C177.143 38.1101 170.577 41.7649 162.317 45.0706C145.803 51.6797 122.63 56.8506 96.7164 59.0013C70.803 61.152 47.0947 59.872 29.7171 56.0757C21.0252 54.1769 13.946 51.6547 8.97024 48.6377C3.98279 45.6135 1.20372 42.154 0.892726 38.4069C0.581735 34.6598 2.75246 30.7895 7.17313 26.9845C11.5834 23.1885 18.15 19.5337 26.4099 16.228C42.9239 9.61891 66.0968 4.44802 92.0102 2.29732C117.924 0.14663 141.632 1.42659 159.009 5.22285C167.701 7.12166 174.781 9.64389 179.756 12.6609C184.744 15.6851 187.523 19.1446 187.834 22.8917Z"
                stroke="white"
              />
            </svg>
            cover
          </strong>
          ...
        </h2>
        <h5 clasName={s.text4}>
          Because if the cover does not impress you what else can?
        </h5>
      </div>
    </div>
  )
}
